import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ip-shared-exemplification-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exemplification-table.component.html',
  styleUrl: './exemplification-table.component.scss',
})
export class ExemplificationTableComponent {}
